<template>
  <div class="page-experiment-detail">
    <ul-scrollbar
      tag="div"
      ref="scrollbar"
      class="scrollbar-body"
      wrapStyle="max-height:100%;overflow-x:auto;"
      >
      <div class="page-experiment-content">
        <div class="select-wrapper">
          <ul-select class="select-teacher" v-model="index" @change="startTimeChange">
            <ul-option
              v-for="item in timeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </ul-option>
          </ul-select>
          <div class="start-time-tips">请选择实验开始时间，可切换实验开始时间查看每次实验成绩详情。</div>
        </div>
        <div class="experiment-info">
          <div class="info-item">实验开始时间：{{experiment.startTime | formatDate}}</div>
          <div class="info-item">实验结束时间：{{experiment.endTime | formatDate}}</div>
          <div class="info-item">状态：{{experiment.status == 1 ? '已完成': '未完成'}}</div>
          <div class="info-item">实验用时：{{experiment.timeUsed | duration}}</div>
          <div class="info-item">实验成绩：{{experiment.newScore || experiment.newScore == 0 ? experiment.newScore : experiment.score}}</div>
          <div class="info-item" v-if="experiment.newScore || experiment.newScore == 0">原始分数：{{experiment.score}}</div>
        </div>
        <div class="experiment-remark" v-if="experiment.comment">
          <div class="remark">
            <span ref="remarkLine">评语：{{ experiment.comment }}</span>
            <!-- <span v-show="infoFlag" @click="infoDialogFlag = true">
              详情>>
            </span> -->
          </div>
          <!-- <div class="remark-info" v-show="infoDialogFlag">
            <div class="tit">
              <span>评语</span>
              <i class="iconfont icon-guanbi1" @click="infoDialogFlag = false"></i>
            </div>
            <div class="text">{{ experiment.comment }}</div>
          </div> -->
        </div>
        <div class="tabs-wrapper">
          <div class="tab-item" :class="{'is-active': tab == 'grade'}" @click="tab = 'grade'">步骤成绩</div>
          <div class="tab-item" :class="{'is-active': tab == 'attach'}" @click="tab = 'attach'">实验文件</div>
        </div>
        <div class="tab-content" v-show="tab == 'grade'">
          <ul-table
            :data="experiment.stepList"
          >
            <ul-table-column
              prop="seq"
              width="68px"
              label="序号">
            </ul-table-column>
            <ul-table-column
              prop="title"
              label="实验步骤名称">
            </ul-table-column>
            <ul-table-column
              prop="startTime"
              width="168px"
              label="开始时间">
              <template slot-scope="scope">
                <span class="">{{scope.row.startTime | formatDate}}</span>
              </template>
            </ul-table-column>
            <ul-table-column
              prop="endTime"
              width="168px"
              label="结束时间">
              <template slot-scope="scope">
                <span class="">{{scope.row.endTime | formatDate}}</span>
              </template>
            </ul-table-column>
            <ul-table-column
              prop="timeUsed"
              width="120px"
              label="实验用时（秒）">
            </ul-table-column>
            <ul-table-column
              prop="expectTime"
              width="120px"
              label="合理用时（秒）">
            </ul-table-column>
            <ul-table-column
              prop="score"
              width="80px"
              label="步骤得分">
            </ul-table-column>
          </ul-table>
          <ul-pagination
            hide-on-single-page
            layout="prev, pager, next"
            :total="experiment.steps.length"
            :page-size.sync="gradeParams.ps"
            :current-page.sync="gradeParams.pn"
          ></ul-pagination>
        </div>
        <div class="tab-content" v-show ="tab == 'attach'">
          <ul-table
            :data="experiment.attachList"
          >
            <ul-table-column
              prop="index"
              width="68px"
              label="序号">
            </ul-table-column>
            <ul-table-column
              prop="title"
              label="文件名称">
            </ul-table-column>
            <ul-table-column
              width="140px"
              label="文件格式">
              <template slot-scope="scope">
                <span class="">{{scope.row.fileName.substring(scope.row.fileName.lastIndexOf('.') + 1).toUpperCase()}}</span>
              </template>
            </ul-table-column>
            <ul-table-column
              prop="endTime"
              width="80px"
              label="操作">
              <template slot-scope="scope">
                <span class="entry-preview" @click="preview(scope.row)">查看</span>
              </template>
            </ul-table-column>
          </ul-table>
          <ul-pagination
            hide-on-single-page
            layout="prev, pager, next"
            :total="experiment.attachments.length"
            :page-size.sync="docParams.ps"
            :current-page.sync="docParams.pn"
          ></ul-pagination>
        </div>
      </div>
    </ul-scrollbar>
    <ResourcePreview
      :resource="currentFile"
      v-if="isResourcePriviewVisible"
      @hide="isResourcePriviewVisible = false"
    ></ResourcePreview>
  </div>
</template>

<script>
import {
  getStuVirtualGradeDetailByTea,
  getStuVirtualGradeDetailByStu
} from '@/api/courseApi/virtual.js'
import { formatDate, formatSeconds } from '@/utils'
import { fileType, getFullPath } from "@/utils/file.js";
import ResourcePreview from "pc/components/resourcePreview.vue";
import { mapGetters } from 'vuex'
import { API_HOST } from "@/config";
import Obs from "@/plugins/ulearning-obs.js";
import { setObsConfig } from '@/utils/file.js'
export default {
  name: 'page-experiment-detail',
  props: ['stuId'],
  data () {
    return {
      isResourcePriviewVisible: false,
      currentFile: {}, //正在预览的附件
      timeList: [],
      index: 0,
      data: [],
      gradeParams: {
        ps: 10,
        pn: 1
      },
      docParams: {
        ps: 10,
        pn: 1
      },
      tab: 'grade',
      infoFlag: false,
      infoDialogFlag: false
    }
  },
  computed: {
    ...mapGetters({ user: 'user/user', token: "user/token" }),
    experimentId () {
      return this.$route.query.experimentId
    },
    experiment () {
      let ex = this.data[this.index] || {}
      ex.steps = ex.steps || []
      ex.attachments = ex.attachments || []
      ex.stepList = ex.steps.filter((item,index) => {
        return item.seq > (this.gradeParams.pn - 1) * this.gradeParams.ps && item.seq <= this.gradeParams.pn * this.gradeParams.ps
      })
      ex.attachList = ex.attachments.filter((item,index) => {
        return item.index > (this.docParams.pn - 1) * this.docParams.ps && item.index <= this.docParams.pn * this.docParams.ps
      })
      return ex
    }
  },
  created () {
    window.test = this
    this.getGradeDetail()
  },
  mounted() {
    setTimeout(()=>{
      this.calculateInfo()
    },200)
  },
  beforeDestroy() {
    this.infoFlag = false
    this.infoDialogFlag = false
  },
  methods: {
    calculateInfo () {
      // if (!this.$refs.remarkLine) {
      //   return
      // }
      // console.dir(this.$refs.remarkLine.offsetWidth);
      // if (this.$refs.remarkLine.offsetWidth >= 837) {
      //   this.infoFlag = true
      // } else {
      //   this.infoFlag = false
      //   this.infoDialogFlag = false
      // }
    },
    startTimeChange () {
      this.docParams.pn = 1
      this.gradeParams.pn = 1
      this.$nextTick(()=>{
        this.calculateInfo()
      })
    },
    getGradeDetail () {
      let promise = ''
      if (this.user.role == 9) {
        promise = getStuVirtualGradeDetailByStu({
          experimentId: this.experimentId
        })
      } else {
        promise = getStuVirtualGradeDetailByTea({
          experimentId: this.experimentId,
          stuUserId: this.stuId
        })
      }
      promise.then(({result}) => {
          this.data = result
          this.timeList = result.map((item, index) => {
            item.attachments.forEach((item, index) => {
              item.index = index + 1
            })
            return {
              label: formatDate(item.startTime, 'yyyy-MM-dd hh:mm:ss'),
              value: index
            }
          })
        })
    },
    preview (item) {
      if (window.self !== window.top) {
        let data = {}
        data.code = 'iframeParentAttachmentPreviewCb'
        data.attachment = item
        window.parent.postMessage(data, '*');
        return
      }
      let filePath = item.url
      let imgList = [{
        url: filePath,
        name: item.title
      }]
      if (fileType(filePath) == "image") {
        this.$viewImage({
          zIndex: 1, // 图片预览的z-index值 一般情况下不需要传
          initialIndex: 0, // 初始化展示图片的序号 默认为0
          imgList: imgList, //图片列表 name可选 url必选
          onDownload: this.download
        });
        
      } else {
        this.currentFile = {
          filePath: filePath,
          fileName: item.title
        }
        this.isResourcePriviewVisible = true;
      }
    },
    download(item) {
      console.log(item)
      let obs = new Obs(setObsConfig({
        uptokenHost: API_HOST,
        authorization: this.token,
      }));
      let ext = item.url.substring(item.url.lastIndexOf('.')).toLowerCase()
      obs.download(item.url, item.name + ext);
    },
  },
  filters: {
    duration (time) {
      if (time === undefined) {
        return '--'
      }
      return formatSeconds(time)
    },
    formatDate (time) {
      return formatDate(time, 'yyyy-MM-dd hh:mm:ss') || '--'
    }
  },
  components: {
    ResourcePreview
  }
}
</script>

<style lang="scss" scoped>
.page-experiment-detail{
  height: 100%;
  background-color: #fff;
}
.ul-scrollbar{
  height: 100%;
}
.page-experiment-content{
  width: 910px;
  margin: 0 auto;
}
.select-wrapper{
  display: flex;
  align-items: center;
  .start-time-tips{
    margin-left: 16px;
    color: $--color-text-secondary;
  }
}
.experiment-info{
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
  padding: 6px 10px;
  background-color: $--background-color-base;
  .info-item{
    width:33.333%;
    padding: 4px 40px 4px 0;
  }
}
.experiment-remark {
  background-color: $--background-color-base;
  padding: 0 10px 8px 10px;
  position: relative;
  .remark-info {
    z-index: 99;
    position: absolute;
    right: 0;
    width: 550px;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #E3E3E9;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.10);
    .tit {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
      padding: 0 15px;
      >span {
        font-size: 18px;
        font-weight: 500;
      }
      >i {
        color: #969696;
        font-size: 16px;
        cursor: pointer;
      }
    }
    .text {
      padding: 14px 15px;
    }
  }
  .remark {
    padding-top: 10px;
    border-top: 1px solid #E3E3E9;
    >span:nth-child(1) {
      // display: inline-block;
      // max-width: 837px;
      // overflow: hidden;
      // text-overflow: ellipsis;
      // white-space: nowrap;
    }
    >span:nth-child(2) {
      float: right;
      color: $--color-link;
      cursor: pointer;
    }
  }
}
.tabs-wrapper{
  display: flex;
  margin-top: 15px;
  .tab-item{
    padding: 5px 12px;
    border-bottom: solid 2px transparent;
    cursor: pointer;
    &:hover{
      color: $--color-primary;
    }
    &.is-active{
      color: $--color-primary;
      border-color: $--color-primary;
    }
  }
}
.ul-table{
  
}
.ul-pagination{
  margin-top: 14px;
  text-align: center;
}
.tab-content{
  border-top: solid 1px $--border-color-base;
  padding-top: 5px;
  padding-bottom: 32px;
  min-height: 300px;
}
.entry-preview{
  color: $--color-link;
  cursor: pointer;
}
</style>